import React from "react";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import List from "../../../styles/atoms/List";
import * as Styles from "./UscBasketItemWrapper.styles";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";

type PropsType = {
    title: string;
    children: React.ReactNode;
};

const UscBasketItemWrapper = (props: PropsType): JSX.Element => {
    const { title, children } = props;
    const [isExpanded, setIsExpanded] = React.useState(true);

    return (
        <Styles.Wrapper>
            {!!title.length && (
                <Styles.Button type="button" onClick={() => setIsExpanded(!isExpanded)} aria-expanded={isExpanded}>
                    <Text variant="h7">{title}</Text>
                    <Icon variant={isExpanded ? "chevron-up" : "chevron-down"} />
                </Styles.Button>
            )}
            <List variant="basket-sub-list" id={`basketlist-${title}`} hidden={!isExpanded}>
                {children}
            </List>
        </Styles.Wrapper>
    );
};

export default UscBasketItemWrapper;
